import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";
import * as yup from "yup";
import {
  InputCheck,
  NuInput,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import ScheduleLayout from "./ScheduleLayout";
import CommonDynamicForm from "../../../../Components/Utils/CommonDynamicForm";
import axiosInstance from "../../../../Services/axiosCommon";
import { useToast } from "../../../../Components/Others/ToastServices";
import { useParams } from "react-router-dom";
import NuDate from "../../../../Components/Utils/NuDate";
import EditIcon from "../../../../Components/Icons/Edit";
import { GetAccess, GetRole } from "../../../../Components/Utils/roles";
import SignatureCanvas from "react-signature-canvas";
import { SubmitButton } from "../../../../Components/Utils/Buttons";
import SendOTP from "./SendOTP";
import ModalContainer from "../../../../Components/Others/ModalContainer";

function Forms() {
  const collectorSign = useRef(null);
  const clientSign = useRef(null);

  const [signOne, setSignOne] = useState(null);
  const [signTwo, setSignTwo] = useState(null);
  const [signThree, setSignThree] = useState(null);
  const [signFour, setSignFour] = useState(null);
  const [signFive, setSignFive] = useState(null);

  const [filesList, setFileList] = useState([]);

  const [collectorDataURL, setCollectorDataURL] = useState(null);
  const [clientDataURL, setClientDataURL] = useState(null);

  const [isCollectorSignEnabled, setIsCollectorSignEnabled] = useState(false);
  const [isClientSignEnabled, setIsClientSignEnabled] = useState(false);

  const [showActionButtons, setShowActionButtons] = useState(false);
  const [showClientActionButtons, setShowClientActionButtons] = useState(false);
  const { scheduleViewId } = useParams();
  const [editModeIndex, setEditModeIndex] = useState(null);

  const toast = useToast();

  const [allFormValues, setAllFormValues] = useState([]);
  const [allForm, setAllForm] = useState([]);
  const [allValue, setAllValue] = useState([]);
  const [isSubmittted, setisSubmittted] = useState(false);

  const [fileRemoveList, setFileRemoveList] = useState([]);

  useEffect(() => {
    if (scheduleViewId) fetchTasks(scheduleViewId);
  }, [scheduleViewId]);

  const fetchTasks = async (value) => {
    try {
      const response = await axiosInstance.get(
        `/tc-schedules/form-fields/${value}`
      );
      const data = response.data?.data;
      console.log("TEST ONE - Data", data);
      setisSubmittted(response?.data?.data?.isFormVerified === false);
      checkAllSubmitted();
      checkOtpEnable();
      if (Array.isArray(data)) {
        setAllFormValues(data);
      } else if (data) {
        setAllFormValues([data]);
      } else {
        setAllFormValues([]);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setAllFormValues([]);
    }
  };

  const [formId, setFormId] = useState(null);

  const fetchAllForm = async (value) => {
    setFormId(value);
    try {
      // setLoading(true);
      const formResponse = await axiosInstance.get(
        `/tc-schedules/form-fields/${value}`
      );
      console.log(formResponse.data?.data);
      setAllForm(formResponse.data?.data);
      let TempArray = [];
      let tempFormData = formResponse.data?.data?.titles || [];
      tempFormData?.forEach((item) => {
        item?.fields?.forEach((field) => {
          console.log("Field - getting", field);
          let ValueInSide = {
            id: field?.id,
            field_type: field?.field_type,
            field_label: field?.field_label,
            value: field?.value,
          };
          TempArray.push(ValueInSide);
        });
      });
      setAllValue(TempArray);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      // setLoading(false);
    }
  };

  const [expandedIndex, setExpandedIndex] = useState(null);
  const [showErrorFeild, setShowErrorFeild] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const handleToggle = (index, id) => {
    setAllForm([]);
    fetchAllForm(id);
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  //   const formik = useFormik({
  //   enableReinitialize: true,
  //   initialValues: {},
  //   validationSchema: yup.object({}),
  //   validateOnChange: false,
  //   validateOnBlur: false,
  //   onSubmit: async (values) => {
  //     try {
  //       let ValuesForForm = {
  //         isSubmitted: true,
  //         values: allValue,
  //         filesToRemove:[],
  //           oldSignone:"",
  //           oldSigntwo:"",
  //           oldSignthree:"",
  //           oldSignfour:"",
  //           oldSignfive:"",
  //       };

  //       let formData = new FormData();
  //       formData.append("json_data", JSON.stringify(ValuesForForm));
  //         formData.append("attachments",filesList)
  //         formData.append("signature1",signOne,`signature1-${formId}-${new Date().toISOString()}.png`)
  //         formData.append("signature2",signTwo,`signature2-${formId}-${new Date().toISOString()}.png`)
  //         formData.append("signature3",signThree,`signature3-${formId}-${new Date().toISOString()}.png`)
  //         formData.append("signature4",signFour,`signature4-${formId}-${new Date().toISOString()}.png`)
  //         formData.append("signature5",signFive,`signature5-${formId}-${new Date().toISOString()}.png`)

  //       const res = await axiosInstance.put(`/tc-schedules/form-submition/${formId}`, formData);

  //       console.log("Form Submitted", res.data);

  //       if (res.data?.status === true) {
  //         toast.open({
  //           type: "success",
  //           message: "Success",
  //           description: res.data?.msg || "Created Successfully.",
  //         });
  //         CloseEditForm(formId);
  //       } else {
  //         toast.open({
  //           type: "error",
  //           message: "Error",
  //           description: res.data?.msg || "Network error.",
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Error submitting form:", error);
  //       toast.open({
  //         type: "error",
  //         message: "Error",
  //         description: error.message || "An unexpected error occurred.",
  //       });
  //     }
  //   },
  // });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validationSchema: yup.object({}), // Add validation fields here if needed
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      try {
        const ValuesForForm = {
          isSubmitted: true,
          values: allValue || {},
          filesToRemove: [],
          oldSignone: "",
          oldSigntwo: "",
          oldSignthree: "",
          oldSignfour: "",
          oldSignfive: "",
        };

        const formData = new FormData();
        formData.append("json_data", JSON.stringify(ValuesForForm));
        filesList &&
          filesList.map((item) => {
            formData.append("attachments", item);
          });

        if (signOne)
          formData.append(
            "signature1",
            signOne,
            `signature1-${formId}-${new Date().toISOString()}.png`
          );
        if (signTwo)
          formData.append(
            "signature2",
            signTwo,
            `signature2-${formId}-${new Date().toISOString()}.png`
          );
        if (signThree)
          formData.append(
            "signature3",
            signThree,
            `signature3-${formId}-${new Date().toISOString()}.png`
          );
        if (signFour)
          formData.append(
            "signature4",
            signFour,
            `signature4-${formId}-${new Date().toISOString()}.png`
          );
        if (signFive)
          formData.append(
            "signature5",
            signFive,
            `signature5-${formId}-${new Date().toISOString()}.png`
          );

        const res = await axiosInstance.put(
          `/tc-schedules/form-submition/${formId}`,
          formData
        );

        if (res.data?.status === true) {
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
          CloseEditForm(formId);
        } else {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
          setShowErrorFeild(true);
          setErrorMessage(res.data?.data || "Network error.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.open({
          type: "error",
          message: "Error",
          description: error.message || "An unexpected error occurred.",
        });
      }
    },
  });

  async function SaveFormData() {
    try {
      let ValuesForForm = {
        isSubmitted: false,
        values: allValue,
      };
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(ValuesForForm));

      const res = await axiosInstance.put(
        `/tc-schedules/form-submition/${formId}`,
        formData
      );

      console.log("Form Submitted", res.data);

      if (res.data?.status === true) {
        toast.open({
          type: "success",
          message: "Success",
          description: res.data?.msg || "Created Successfully.",
        });
        CloseEditForm(formId);
      } else {
        toast.open({
          type: "error",
          message: "Error",
          description: res.data?.msg || "Network error.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.open({
        type: "error",
        message: "Error",
        description: error.message || "An unexpected error occurred.",
      });
    }
  }

  async function CloseEditForm(id) {
    await axiosInstance
      .put(`/tc-schedules/close-form/${scheduleViewId}`)
      .then((res) => {
        console.log("eeeee", res?.data?.status);

        if (res?.data?.status) {
          console.log("ok");
          setEditModeIndex(null);
          fetchTasks(scheduleViewId);
        } else {
          console.log("error");
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      })
      .catch((error) => {
        toast.open({
          type: "error",
          message: "Error",
          description: error?.response?.data?.msg || "Network error.",
        });
      });
  }

  async function OpenEditForm(index, id, workingUser) {
    if (workingUser) {
      CloseEditForm(id);
    } else {
      await axiosInstance
        .put(`/tc-schedules/open-form/${id}`)
        .then((res) => {
          console.log("eeeee", res?.data?.status);

          if (res?.data?.status) {
            fetchTasks(scheduleViewId);
            setEditModeIndex(editModeIndex === index ? null : index);
          } else {
            console.log("error");
            toast.open({
              type: "error",
              message: "Error",
              description: res.data?.msg || "Network error.",
            });
          }
        })
        .catch((error) => {
          toast.open({
            type: "error",
            message: "Error",
            description: error?.response?.data?.msg || "Network error.",
          });
        });
    }
  }
  useEffect(() => {
    const interval = setInterval(() => {
      if (collectorSign.current) {
        collectorSign.current.off();
        clearInterval(interval);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (collectorSign.current) {
      isCollectorSignEnabled
        ? collectorSign.current.on()
        : collectorSign.current.off();
    }
  }, [isCollectorSignEnabled]);

  // Client
  useEffect(() => {
    const interval = setInterval(() => {
      if (clientSign.current) {
        clientSign.current.off();
        clearInterval(interval);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (clientSign.current) {
      isClientSignEnabled ? clientSign.current.on() : clientSign.current.off();
    }
  }, [isClientSignEnabled]);
  const [open, setOpen] = useState(false);

  const handleSendOTP = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  const [allSubmitted, setAllSubmitted] = useState(false);

  const checkAllSubmitted = async () => {
    try {
      const response = await axiosInstance.get(
        `/tc-schedules/check-submitted/${scheduleViewId}`
      );
      console.log("Check Submitted Status", response.data);
      // fetchTasks(scheduleViewId)

      setAllSubmitted(response.data?.data === true);
    } catch (error) {
      console.error("Error checking submission status:", error);
    }
  };

  useEffect(() => {
    if (scheduleViewId) {
      checkAllSubmitted();
      fetchTasks(scheduleViewId);
    }
  }, [scheduleViewId]);

  const [otpEnable, setOtpEnable] = useState(false);
  const [openEnable, setEnableOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // Fetch OTP enable status
  const checkOtpEnable = async () => {
    try {
      const response = await axiosInstance.get(`/tc-schedules/is-otp-enabled`);
      console.log("Check Submitted Status", response.data);

      if (response.data?.status) {
        setOtpEnable(response.data.data === true);
      } else {
        console.warn("Unexpected response status:", response.data);
        setOtpEnable(false);
      }
    } catch (error) {
      console.error("Error checking submission status:", error);
      setOtpEnable(false);
    }
  };

  // On button click, open confirm popup
  const handleEnableOTP = () => setEnableOpen(true);

  // On confirm, call verify API
  const handleVerifyOTP = () => {
    setLoading(true);
    axiosInstance
      .put(`/tc-schedules/verify-otp/${scheduleViewId}`, { opt: "" })
      .then((res) => {
        if (res.data.status) {
          toast.open({
            type: "success",
            message: "OTP Verified",
          });
          fetchTasks(scheduleViewId);
        } else {
          toast.open({
            type: "error",
            message: "Invalid OTP",
            description: res.data.msg,
          });
        }
      })
      .catch((err) => {
        toast.open({
          type: "error",
          message: "Network Error",
          description: err.message,
        });
      })
      .finally(() => {
        setLoading(false);
        setEnableOpen(false);
      });
  };

  // On page load, check status and fetch tasks
  useEffect(() => {
    checkOtpEnable();
    fetchTasks(scheduleViewId);
  }, [scheduleViewId]);

  return (
    <ScheduleLayout>
      <div className="w-full h-full mt-0.5 overflow-y-auto">
        {
          <div className="w-full mx-auto h-[calc(100vh-175px)] overflow-y-scroll  pb-8">
            {allFormValues?.map((item, index) => {
              return (
                <>
                  <div
                    key={item?.id || index}
                    className="border-b border-gray-300"
                  >
                    <div
                      className="md:flex justify-between items-center p-2  bg-white "
                      // onClick={() => handleToggle(index, item?.id)}
                    >
                      <h1 className="text-sm font-semibold w-[50%]">
                        {item.formName || " - "}
                      </h1>
                      <div className="flex 2xl:w-[50%] md:w-[65%] gap-2 justify-end items-center">
                        <div className="border border-baseColor-primary h-auto w-full bg-gray-50 rounded-lg md:mx-4  md:ml-2 p-2">
                          <div className="md:flex gap-2 w-full">
                            <div className="flex gap-2 w-[50%] ">
                              <table className=" w-full text-xs">
                                <tr className=" w-full">
                                  <td className=" w-[90px] pb-2 font-medium">
                                    Inspector
                                  </td>
                                  <td className=" w-[5px] pb-2">:</td>
                                  <td className=" pb-2  text-[#606279]">
                                    {item?.workingUserName || " "}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" w-[90px]  font-medium">
                                    Updated By
                                  </td>
                                  <td className=" w-[5px] ">:</td>
                                  <td className="  text-[#606279] font-medium">
                                    <div>
                                      <p>{item?.updatedByName || " "}</p>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" w-[90px] "></td>
                                  <td className=" w-[5px]"></td>
                                  <td>
                                    <div>
                                      {item?.updatedByName &&
                                        item?.updatedOn && (
                                          <p className=" text-[10px] text-[#606279]">
                                            <NuDate
                                              value={item?.updatedOn}
                                              format="DD-MMM-YYYY, "
                                            />
                                            {/* <NuDate
                                              value={item?.updatedOn}
                                              format="hh:mm a"
                                            /> */}
                                          </p>
                                        )}
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </div>
                            <div className="flex gap-2 w-[50%] ">
                              <table className=" w-full text-xs">
                                <tr className=" w-full">
                                  <td className=" w-[110px] pb-1 font-medium">
                                    Status
                                  </td>
                                  <td className=" w-[5px] pb-1">:</td>
                                  <td className=" pb-1  text-[#606279] font-medium">
                                    {item?.status || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" w-[110px]  font-medium">
                                    Completion Date
                                  </td>
                                  <td className=" w-[5px] ">:</td>
                                  <td className="  text-[#606279] font-medium">
                                    <div>
                                      <p>
                                        <span>
                                          <NuDate
                                            value={item?.submittedOn}
                                            format="DD-MMM-YYYY, "
                                          />
                                        </span>
                                        {/* <span>
                                          <NuDate
                                            value={item?.submittedOn}
                                            format="hh:mm a"
                                          />
                                        </span> */}
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" w-[110px] "></td>
                                  <td className=" w-[5px]"></td>
                                  <td>
                                    <div></div>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="flex gap-6 items-center w-[50%] justify-end mr-1">
    <div className="flex flex-col gap-2 w-[50%]">
                     
                      {item?.workingUser != null && (
                          <div className=" flex items-center overflow-hidden rounded-full text-[10px] 2xl:text-xs   ">
                            <div className="py-1 h-6  bg-white px-1 rounded-s-full font-medium flex items-center border border-emerald-300">
                              Inspector{"-"}
                            </div>
                            <div className="py-1 h-6  bg-emerald-300 text-white font-medium px-1 rounded-e-full flex items-center">
                              {item?.workingUserName || "No User"}
                            </div>
                          </div>
                        )} */}
                      {/* <div className="flex items-center overflow-hidden rounded-full text-[10px] 2xl:text-xs border border-blue-400 w-fit">
                         <div className="flex flex-col justify-center bg-white px-2 py-1 rounded-s-full h-6">
                           <p className="font-medium ">Updated By</p>
                           <div className="flex gap-1">
                             <span className="line-clamp-1">
                               <NuDate value={item?.updatedAt} format="DD-MMM-YYYY," />
                             </span>
                             <span>
                               <NuDate value={item?.updatedAt} format="hh:mm a" />
                             </span>
                           </div>
                         </div>
                         <div className="flex items-center justify-center bg-blue-400 text-white font-medium px-3 h-7 rounded-e-full">
                           {item?.updatedByName || "No User"}
                         </div>
                       
                       </div> */}
                      {/*                        
                                                                        <div className="flex items-center overflow-hidden rounded-full text-[10px] 2xl:text-xs border border-blue-400 w-fit">
                             <div className="flex items-center bg-white px-2 h-6 rounded-s-full  font-medium">
                           Updated By
                         </div> */}

                      {/* <div className="flex flex-col justify-center bg-blue-400 text-white font-medium px-3 h-6 rounded-e-full">
                           <div className="text-[11px]">{item?.updatedByName || "No User"}</div>
                           <div className="flex gap-0.5 text-[9px] text-gray-200">
                             <span>
                               <NuDate value={item?.updatedAt} format="DD-MMM-YYYY," />
                             </span>
                             <span>
                               <NuDate value={item?.updatedAt} format="hh:mm a" />
                             </span>
                           </div>
                         </div>
                       </div> */}

                      {/* </div>    <div className="flex flex-col gap-2 w-[50%]">

                        <div className=" flex items-center overflow-hidden rounded-full text-[10px] 2xl:text-xs   ">
                        <div className="py-1 h-6  bg-white px-1 rounded-s-full font-medium flex items-center border border-green-400">
                            Status{" "}
                          </div>
                          <div className="py-1 h-6  bg-green-700 text-white font-medium px-1 rounded-e-full flex items-center">
                            {item?.status || "Yet To Start"}
                          </div>
                          
                        </div>
                        <div className=" flex  items-center overflow-hidden rounded-full text-[10px] 2xl:text-xs   ">
                                                 <div className="py-1 h-6  bg-white  px-1 rounded-s-full font-medium flex items-center border border-yellow-400">
                                                   Completion Date{" "}
                                                 </div>
                                                 <div className=" py-1 h-6 bg-yellow-400 px-1 text-white rounded-e-lg flex flex-col justify-center font-medium ">
                                                   <div className=" text-[10px] line-clamp-1">
                                                     {" "}
                                                     <NuDate
                                                       value={item?.updatedAt}
                                                       format="DD-MM-YYYY,"
                                                     />
                                                   </div>
                                                   <div className=" text-[10px]">
                                                     <NuDate value={item?.updatedAt} format="hh:mm a" />
                                                     
                                                   </div>
                                                 </div>
                                               </div>
                        </div>
                      </div> */}
                      {GetAccess("commissioning_schedules_form_edit") &&
                        (GetRole() || isSubmittted) && (
                          <span
                            onClick={() =>
                              OpenEditForm(index, item?.id, item?.workingUser)
                            }
                            className={`cursor-pointer md:mr-4 md:p-1 md:rounded-lg md:border w-6 h-6 mt-2 md:mt-0
                          ${
                            editModeIndex === index
                              ? "bg-green-100 border-green-500"
                              : "bg-red-100 border-red-500"
                          }`}
                          >
                            <EditIcon
                              color={editModeIndex === index ? "green" : "red"}
                              height={12}
                            />
                          </span>
                        )}
                      <span
                        className={`cursor-pointer p-1 w-auto mt-2 md:mt-0 h-auto rounded-lg border transition flex items-center justify-center 
    ${
      expandedIndex === index
        ? "bg-blue-100 border-blue-500"
        : "bg-gray-100 border-gray-300"
    }`}
                        onClick={() => handleToggle(index, scheduleViewId)}
                      >
                        {expandedIndex === index ? (
                          <ToggleUp />
                        ) : (
                          <ToggleDown />
                        )}
                      </span>
                    </div>
                  </div>
                  {expandedIndex === index && (
                    <form onSubmit={formik.handleSubmit}>
                      <CommonDynamicForm
                        formData={allForm?.titles || []}
                        formik={formik}
                        expandedIndex={expandedIndex}
                        index={index}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        SaveFormData={SaveFormData}
                        editModeIndex={editModeIndex}
                        FileAttachment={setFileList}
                        SignOne="Client"
                        SignTwo="Inspector"
                        SignThree="Collector"
                        SignFour="Conductor"
                        SignFive="Supplier"
                        setSignFunOne={setSignOne}
                        setSignFunTwo={setSignTwo}
                        setSignFunThree={setSignThree}
                        setSignFunFour={setSignFour}
                        setSignFunFive={setSignFive}
                        hasSignThree={true}
                        hasSignFour={true}
                        hasSignFive={true}
                        allData={allForm}
                        setFileRemoveList={setFileRemoveList}
                        fileRemoveList={fileRemoveList}
                      />
                    </form>
                  )}
                </>
              );
            })}
          </div>
        }
        {allSubmitted && isSubmittted && otpEnable && (
          <div className="w-full   p-4 flex justify-end">
            <SubmitButton name="Verify with OTP" handleClick={handleSendOTP} />
          </div>
        )}
        {!otpEnable && isSubmittted && (
          <div className="w-full p-4 flex justify-end">
            <SubmitButton name="Verify" handleClick={handleEnableOTP} />
          </div>
        )}
      </div>
      {open && (
        <SendOTP
          scheduleViewId={scheduleViewId}
          onClose={() => setOpen(false)}
          fetchTasks={fetchTasks}
        />
      )}{" "}
      {openEnable && (
        <ModalContainer
          visiable={openEnable}
          title="Confirm"
          content={
            <div>
              <p>
                Are You Sure! You want to{" "}
                <span className="font-semibold">Verify</span> this Form?
              </p>
            </div>
          }
          handleClick={handleVerifyOTP}
          closeModal={() => setEnableOpen(false)}
          isLoading={loading}
        />
      )}
      {showErrorFeild && (
        <ModalContainer
          closeModal={() => setShowErrorFeild(false)}
          visiable={showErrorFeild}
          title=""
          hasButton={false}
          content={
            <div className=" max-w-[65vw] max-h-[90vh] min-h-[30vh]  min-w-[65vw] 2xl:min-w-[45vw]">
              <div className="w-full h-7 mb-2 flex justify-between items-center">
                <p className=" font-semibold text-sm">Feilds to be checked</p>
                <div className=" flex gap-4 items-center">
                  <button
                    className=" text-white bg-red-600"
                    onClick={() => {
                      setShowErrorFeild(false);
                      setErrorMessage("");
                    }}
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div className=" w-full max-h-[calc(90vh-32px)] overflow-y-auto">
                <pre>{ErrorMessage}</pre>
              </div>
            </div>
          }
        />
      )}
    </ScheduleLayout>
  );
}
export default Forms;
